import React, { Component } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageOfficeWorking from "../../images/office-working.png";

class SharedOwnershipPurchaseIntro extends Component {
  render() {
    return (
      <React.Fragment>
        <ScrollToTop />
        <Card title="We need to find out more about your shared ownership purchase" removeTopPadding headingSize="1">
          <p>
            Because you told us you are buying a shared ownership property, we need to ask you some questions about the
            housing association.
          </p>
          <p>This form should take around five minutes to complete.</p>
          <Action onClick={() => this.props.onStepComplete({})}>Let’s get started</Action>
        </Card>
        <Image src={imageOfficeWorking} fullWidth />
      </React.Fragment>
    );
  }
}

export default SharedOwnershipPurchaseIntro;
